import React from 'react';
import { EditorPanel } from './EditorPanel';

interface WorkflowEditorProps {
  sendingToSiteflow?: boolean;
  siteflowError?: string;
  siteflowMessage?: string;
  onSendToSiteflow?: (projectId: string, familyId: string) => void;
}

export function WorkflowEditor({ sendingToSiteflow, siteflowError, siteflowMessage, onSendToSiteflow }: WorkflowEditorProps) {
  return (
    <div className="flex-1 min-h-0 bg-background flex flex-col">
      <EditorPanel
        className="flex-1 min-h-0"
        sendingToSiteflow={!!sendingToSiteflow}
        siteflowError={siteflowError}
        siteflowMessage={siteflowMessage}
        onSendToSiteflow={onSendToSiteflow}
      />
    </div>
  );
}
